import { z } from 'zod'
import { message } from './message'
import { comment } from '../comment/comment'
import { paginatedSearchQuery } from '../zod/pagination'

/**
 t('candidateStatus.new')
 t('candidateStatus.contacted')
 t('candidateStatus.conversation')
 t('candidateStatus.finished')
 */
export const candidateStatus = z.enum(['new', 'contacted', 'conversation', 'finished'])

export const candidate = z.object({
    source: z.enum(['manual', 'import', 'api', 'facebook_lead_form', 'public_form', 'unknown']),
    id: z.string(),
    conversationLanguage: z.string().nullable().optional(),
    campaignId: z.string(),
    columnId: z.string().nullable(),
    columnOrder: z.string().nullable(),
    companyColumnId: z.string().nullable(),
    companyColumnOrder: z.string().nullable(),
    name: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phone: z.string(),
    email: z.string().nullable(),
    avatar: z.string(),
    positive: z.string().array(),
    negative: z.string().array(),
    status: candidateStatus,
    campaign: z
        .object({
            id: z.string(),
            title: z.string(),
            whatsappBusinessAccountId: z.string().nullable().optional(),
        })
        .optional(),
    compatibility: z.number().nullable(),
    messages: z.array(message).optional(),
    comments: z.array(comment).optional(),
    commentCount: z.number().optional(),
    archivedAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
})

export type Candidate = z.infer<typeof candidate>
export type CandidateStatus = z.infer<typeof candidateStatus>

export const candidateQuery = paginatedSearchQuery({
    filters: z.object({
        campaignId: z.string().array().optional(),
        columnId: z.string().array().optional(),
        companyColumnId: z.string().array().optional(),
        archived: z.boolean().array().optional(),
        search: z.string().array().optional(),
        status: candidateStatus.array().optional(),
    }),
    include: z.enum(['messages', 'comments', 'campaign']).array().optional(),
    sort: z.enum([
        'created_at',
        '-created_at',
        'updated_at',
        '-updated_at',
        'archived_at',
        '-archived_at',
        'column_order',
        '-column_order',
        'company_column_order',
        '-company_column_order',
        '-compatibility',
    ]),
}).and(z.object({ archived: z.boolean().optional() }))

export type CandidateQuery = z.infer<typeof candidateQuery>

export function isRejectable(candidate: Candidate) {
    const messages = candidate.messages || []

    return messages.length !== 0
}
